// ForeignSubsidiaryRegistration.jsx
import React from "react";

export default function ForeignSubsidiaryRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Foreign Subsidiary Company Registration in India.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Foreign Subsidiary
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Foreign Subsidiary Company Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks offers professional support for Foreign
            Subsidiary Company Registration in India, helping overseas
            businesses establish a locally incorporated company that complies
            with company law and foreign investment regulations. [web:31][web:34]
          </p>
          <p className="text-gray-700">
            The team assists with planning the shareholding structure,
            fulfilling resident‑director requirements, and coordinating all
            filings so the foreign parent can operate in India through a clear,
            compliant corporate vehicle. [web:32][web:36]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/5668781/pexels-photo-5668781.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Foreign management team planning subsidiary registration in India"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Foreign Subsidiary Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks coordinates with the foreign parent and
              Indian stakeholders to collect, notarise or apostille, and format
              documents as required for incorporation and FDI compliance. [web:31][web:33]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Parent company charter documents (Certificate of
                  Incorporation, Memorandum and Articles, or equivalent),
                  typically notarised/apostilled in the home country. [web:32][web:33]
                </li>
                <li>
                  Board resolution from the foreign parent approving formation
                  of the Indian subsidiary and authorising a representative. [web:31][web:32]
                </li>
                <li>
                  Details and KYC of authorised representative and proposed
                  directors (passport, address proof, photographs, contact
                  details). [web:31][web:32]
                </li>
                <li>
                  Proof of registered office address in India (rent/lease
                  agreement or ownership papers, recent utility bill, and NOC
                  from premises owner). [web:33][web:34]
                </li>
                <li>
                  Digital Signature Certificates (DSC) and Director
                  Identification Numbers (DIN) for proposed directors. [web:31][web:34]
                </li>
                <li>
                  Any sector‑specific or FDI‑route related approvals, if
                  required under Indian FDI policy. [web:32][web:38]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm blends foreign‑investment know‑how with Indian corporate
              compliance, giving international businesses a single, reliable
              point of support for entering and operating in India. [web:32][web:37]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Foreign Company Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance on eligibility, resident‑director norms, FDI caps,
                  and RBI/FEMA requirements applicable to foreign‑owned Indian
                  subsidiaries. [web:32][web:36]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Legal Documentation
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in drafting and reviewing incorporation papers, board
                  resolutions, and declarations to ensure they meet Indian legal
                  standards and procedural norms. [web:31][web:34]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional End-to-End Service
                </h3>
                <p className="text-gray-700 text-sm">
                  End‑to‑end coordination from name reservation and filing
                  incorporation forms to post‑incorporation registrations and
                  ongoing compliance support. [web:31][web:37]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
